import React, { Component } from 'react';

export default class ErrorDialog extends Component {
  constructor(props) {
    super (props)
    this.state = {
      isShow: false
    }
  }

  _handleCloseDialog(){
    // console.log('_handleCloseDialog:::')
    // window.$('body').find('.popup_dialog').css('display', 'none')
    // window.$('body').find('.mask').css('display', 'none')
    setTimeout(() => {
      const {closeCallback} = this.props
      closeCallback({isShow: false})
    }, 500)
  }

  _handle2OhterActivities() {
    window.location.href = `https://m.jr.jd.com/vip/sign/html/index.html?id=1192&activityid=1158`
  }

  render() {
    return (
      <div className='mainWrap'>
        <div className='mask black'>
          {<span className='btn_close' onClick={this._handleCloseDialog.bind(this)}></span>}
        </div>
        <div className='popup_dialog'>
          <div className='popup_pic'></div>
          <div className='popup_bgColor'>
            <div className='water_bg'></div>
            <div className='main_info'>
              <div className="firendlyTip">
                <p>活动太火爆啦</p>
                <p>休息一下，稍后再试试</p>
              </div>
              <div className="whiteSpace"></div>
              <div className='btn yellow' onClick={this._handle2OhterActivities.bind(this)} clstag="jr|keycount|yqsbhby|9">去其它活动看看</div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
